import { FilterAndSortButtonProps } from './components/FilterAndSortButton';
import FilterButton from './components/FilterButton';
import FilterButtonGroup from './components/FilterButtonGroup';
import FilterCheckboxSection, {
  FilterCheckboxSectionProps,
} from './components/FilterCheckboxSection';
import FilterDivider from './components/FilterDivider';
import FilterSearchBar, {
  FilterSearchBarProps,
} from './components/FilterSearchBar';
import FilterSurface from './components/FilterSurface';
import FilterTitle from './components/FilterTitle';

export { default as FilterMobile } from './components/FilterMobile';
export { default as FilterDesktop } from './components/FilterDesktop';

const Filter = {
  CheckboxSection: FilterCheckboxSection,
  Divider: FilterDivider,
  SearchBar: FilterSearchBar,
  Surface: FilterSurface,
  ButtonGroup: FilterButtonGroup,
  Button: FilterButton,
  Title: FilterTitle,
};

export type {
  FilterCheckboxSectionProps,
  FilterAndSortButtonProps,
  FilterSearchBarProps,
};

export default Filter;
